import Heading from "components/Heading";
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Button, Col, Container, Row, Table, UncontrolledDropdown,
  DropdownToggle, DropdownMenu, DropdownItem, Alert
} from "reactstrap";
import { errorHandler, toLocaleTime } from "utils/Api";
import styles from "./style.module.scss";
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import { countryList, MOVEMENT_STATUS } from "utils/Constants";
import { deleteCargoMovement, getCargoMovements } from "api/CargoMovementApi";
import LoadingTBody from "components/LoadingTBody";
import { showAlert } from "utils/Alert";
import DeleteModal from "components/DeleteModal";


const CargoMovement = props => {
  let navigate = useNavigate();
  const [cargosList, setCargosList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [toDeleteCargo, setToDeleteCargo] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetchCargoMovements();
  }, [cargosList.length]);

  const fetchCargoMovements = () => {
    getCargoMovements().then((boxes) => {
      setCargosList(boxes);
    }).catch((e) => errorHandler(e, "fetch cargo movements error"))
      .finally(() => {
        setIsLoading(false);
      });
  }

  const renderList = () => {
    return cargosList.map((cargo) => {
      let created = toLocaleTime(cargo.createdAt);
      return (
        <tr key={cargo.id}>
          <td>
            {cargo.secuencia}
          </td>
          <td>
            {cargo.bl_guia}
          </td>
          <td>
            {cargo.agente_transporte}
          </td>
          <td>
            {countryList[cargo.origin]}
          </td>
          <td>
            {countryList[cargo.destino]}
          </td>
          <td>
            {MOVEMENT_STATUS[cargo.status]}
          </td>
          <td>
            {created}
          </td>
          <td>
            {rowActions(cargo)}
          </td>
        </tr>
      );
    });
  }

  const deleteCargo = (cargo) => {
    setIsLoading(true);
    deleteCargoMovement(cargo)
      .then(async (r) => {
        showAlert("success", `El File #${cargo.secuencia} fue eliminado correctamente`);
        toogleModal();
      }).catch(e => {
        errorHandler(e);
        showAlert("danger", `No fue posible eliminar el File #${cargo.secuencia}`);
      })
      .finally(() => fetchCargoMovements());
  }

  const showDeleteConfirm = (cargo) => {
    if (!cargo.status || MOVEMENT_STATUS[cargo.status] === MOVEMENT_STATUS.onWait) {
      setToDeleteCargo(cargo);
      setIsModalOpen(true);
    } else {
      showAlert("danger", `No es posible eliminar el File #${cargo.secuencia}, por que esta actualmente en transito o ya fue entregado`);
    }
  }

  const toogleModal = (e) => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      setToDeleteCargo({});
    }
  }

  const rowActions = (cargo) => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className={styles.threedotsBtn} >
          <ThreeDotsVertical size="1.5rem" />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>
            Acciones
          </DropdownItem>
          <DropdownItem onClick={(e) => { navigate(`/admin/cargo-movement/edit/${cargo.id}`) }}>
            Editar Movimiento
          </DropdownItem>
          <DropdownItem onClick={(e) => showDeleteConfirm(cargo)}>
            Eliminar Movimiento
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  return (
    <>
      <Heading headingLevel="h2" className="pt-4" label="Files" sticky >
        <Col sm={2}>
          <Button
            className="float-end"
            color="success"
            onClick={(e) => navigate("/admin/cargo-movement/add")}
          > Crear File</Button>
        </Col>
      </Heading>
      <Container>
        <Row>
          <Col>
            <Table hover>
              <thead>
                <tr>
                  <th>
                    #
                  </th>
                  <th>
                    BL / Guia
                  </th>
                  <th>
                    Agente Transporte
                  </th>
                  <th>
                    Origen
                  </th>
                  <th>
                    Destino
                  </th>
                  <th>
                    Estado
                  </th>
                  <th>
                    Fecha Ingreso
                  </th>
                  <th width="2%"></th>
                </tr>
              </thead>
              <LoadingTBody isLoading={isLoading}>
                {renderList()}
              </LoadingTBody>
            </Table>
            {toDeleteCargo && toDeleteCargo.id && (
              <DeleteModal
                title="Eliminar File"
                toogle={toogleModal}
                isOpen={isModalOpen}
                onDelete={() => { deleteCargo(toDeleteCargo) }}>
                <Alert color="warning">
                  Los Warehouse agregados a este File van a ser liberados
                </Alert>
                Esta seguro que desea eliminar el File #{toDeleteCargo.secuencia}?
              </DeleteModal>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CargoMovement;
